import { track } from '@/features/shared/analytics/trackingQueue'
import { AnalyticsEvent } from '@shipt/analytics-member-web'
import { urlPathnameToLocationName } from '@/features/shared/analytics/utils'

export const trackLiveChatConversationStarted = () => {
  track({
    eventName: AnalyticsEvent.LiveChatConversationStarted,
    properties: {
      location: urlPathnameToLocationName(),
    },
  })
}

export const trackLiveChatConversationEnded = () => {
  track({
    eventName: AnalyticsEvent.LiveChatConversationEnded,
    properties: {
      location: urlPathnameToLocationName(),
    },
  })
}
